import {Typography} from 'components/Typography';
import React, {FC, ReactNode, useState} from 'react';
import style from './style.module.scss';
import {Tooltip} from 'components/Tooltip';
import cs from 'classnames';

export interface IProps {
    copyText: string;
    className: string;
    children: ReactNode;
}

export const CopyToClipboard: FC<IProps> = ({copyText, children, className}) => {
    const [isCopy, setIsCopy] = useState(false);

    const handleClick = async () => {
        try {
            await navigator.clipboard.writeText(copyText);

            setIsCopy(true);

            setTimeout(() => {
                setIsCopy(false);
            }, 1000);
        } catch (e) {
            console.error(e);
        }
    };

    if (!children) {
        return null;
    }

    return (
        <Tooltip
            className={style.tooltip}
            overlay={
                <div className={style.popup}>
                    <Typography variant={'label-12-m'}>Скопировано</Typography>
                </div>
            }
            isOpen={isCopy}
            openOnClick={true}
            positionStrategy={'fixed'}
            place={'bottom'}
        >
            <button type={'button'} className={cs(style.button, className)} onClick={handleClick}>
                {children}
            </button>
        </Tooltip>
    );
};
